import styled from "styled-components";
import { Modal, Form, Button, Select } from "antd";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 14px;
    overflow: hidden;
    padding: 0;
    height: auto;
    width: ${(props) => (props.alterUx ? "500px" : "667px")} !important;
  }
  .ant-modal-header {
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    border-bottom: none;
    padding: 20px 24px 0px 24px;
    margin-bottom: 0;
  }
  .ant-modal-close {
    display: none !important;
  }
  .ant-modal-close-x {
    display: none !important;
  }
  .ant-modal-title {
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
    padding-bottom: 16px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 16px;
  }
`;

export const FormContainer = styled.div`
  padding: 0;
`;

export const FormItem = styled(Form.Item)`


  .ant-form-item-label {
    padding-bottom: 4px;
  }

  .ant-form-item-label > label {
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 18.86px;
    color: #1f1f1f;
  }

  .ant-form-item-explain,
  .ant-form-item-explain-error {
    font-size: 12px;
    font-family: "Open Sans", sans-serif;
    margin-top: -8px;
    min-height: auto;
    line-height: 1.4;
    color: #ff4d4f;
  }

  .ant-input {
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;

    &:focus {
      border-color: #11a7d9;
      box-shadow: 0 0 0 2px rgba(17, 167, 217, 0.1);
    }

    &:hover {
      border-color: #11a7d9;
    }
  }

  .ant-input::placeholder {
    color: #bfbfbf;
    font-family: "Open Sans", sans-serif;
  }

  textarea.ant-input {
    resize: none;
    min-height: 80px;
    padding: 8px 12px;
    line-height: 1.5;
  }
`;

export const RequiredLabel = styled.span`
  color: #ff4d4f;
  margin-left: 4px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
`;

export const CancelButton = styled(Button)`
  width: ${(props) => (props.alterUx ? "221px" : "112px")};
  height: 34px;
  border-radius: ${(props) => (props.alterUx ? "10px" : "5px")};
  background: ${(props) =>
    props.alterUx ? "#FFFFFF" : "rgba(226, 232, 240, 1)"} !important;
  border-color: ${(props) =>
    props.alterUx
      ? "rgba(17, 167, 217, 1)"
      : "rgba(226, 232, 240, 1)"} !important;
  color: ${(props) =>
    props.alterUx ? "rgba(17, 167, 217, 1)" : "rgba(0, 34, 68, 1)"} !important;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 25.14px;
  text-transform: uppercase;
  text-align: center;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-transform: ${(props) => (props.alterUx ? "none" : "uppercase")};

  &:hover,
  &:focus {
    background: ${(props) =>
      props.alterUx ? "#F0F4F8" : "#CBD5E1"} !important;
    border-color: ${(props) =>
      props.alterUx ? "rgba(17, 167, 217, 1)" : "#CBD5E1"} !important;
    color: ${(props) =>
      props.alterUx
        ? "rgba(17, 167, 217, 1)"
        : "rgba(0, 34, 68, 1)"} !important;
  }
`;

export const ConfirmButton = styled(Button)`
  width: ${(props) => (props.alterUx ? "221px" : "112px")};
  height: 34px;
  border-radius: ${(props) => (props.alterUx ? "10px" : "5px")};
  background: ${(props) =>
    props.alterUx ? "rgba(17, 167, 217, 1)" : "#002244"} !important;
  border-color: ${(props) =>
    props.alterUx ? "rgba(17, 167, 217, 1)" : "#002244"} !important;
  color: #ffffff !important;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 25.14px;
  text-transform: uppercase;
  text-align: center;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover,
  &:focus {
    background: ${(props) =>
      props.alterUx ? "rgb(18, 128, 164)" : "#001933"} !important;
    border-color: ${(props) =>
      props.alterUx ? "rgb(17, 123, 158)" : "#001933"} !important;
    color: #ffffff !important;
  }
`;

export const CharacterCount = styled.div`
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-top: 4px;
  font-family: "Open Sans", sans-serif;
`;

export const SelectReason = styled(Select)`
  width: 100%;
  margin-bottom: 25px;
  .ant-select-selector {
    border-radius: 6px !important;
  }
`;
